import { IBanner } from "../models/bannerModel";
import IDistrict from "../models/districtModel";
import IProvince from "../models/provinceModel";
import IWard from "../models/wardModel";
import { common } from "../repositories/";

export const getProvinces = async (
  callback: (data: IProvince[], err: any) => void
) => {
  let result: IProvince[] = [];
  try {
    const rs = await common.getProvinces();
    callback(rs.data, null);
  } catch (error) {
    callback(result, error);
  }
};

export const getDistricts = async (
  provinceId: any,
  callback: (data: IDistrict[], err: any) => void
) => {
  let result: IDistrict[] = [];
  try {
    const rs = await common.getDistricts(provinceId);
    callback(rs.data, null);
  } catch (error) {
    callback(result, error);
  }
};

export const getWards = async (
  districtId: any,
  callback: (data: IWard[], err: any) => void
) => {
  let result: IWard[] = [];
  try {
    const rs = await common.getWards(districtId);
    callback(rs.data, null);
  } catch (error) {
    callback(result, error);
  }
};

export default {
  getProvinces,
  getDistricts,
  getWards,
  getBanner: async (
    type: string,
    query: any,
    callback: (data: IBanner[], err: any) => void
  ) => {
    let result: IBanner[] = [];
    try {
      const rs = await common.getBanners(type, query);
      callback(rs.data, null);
    } catch (error) {
      callback(result, error);
    }
  },
  getStores: async (query: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await common.getStores(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getDistrictStore: async (callback: (data: any, err: any) => void) => {
    let result: any = [];
    try {
      const rs = await common.getDistrictStore();
      callback(rs.data, null);
    } catch (error) {
      callback(result, error);
    }
  },
  getStoresWithFilters: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await common.getStoresWithFilters(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getContacts: async (callback: (data: any, err: any) => void) => {
    try {
      const rs = await common.getContacts();
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getStore: async (id: string, callback: (data: any, err: any) => void) => {
    try {
      const rs = await common.getStore(id);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
};
